module.exports = __webpack_public_path__ + "media/images/company/company_01_02-0234eb09113efb71a3306951a037489e.jpg";